/******* Angular Resourse *******/
import { Component, OnInit, OnDestroy, ElementRef, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

/******* Core Resourse *******/
import { CoreConfigService } from '@core/services/config.service';
import { UtilsService } from '@core/services/utils.service';

/******* Tyep *******/
import { CoreConfig } from '@core/types';
import { environment } from 'environments/environment';
import { AccessTokenService } from '@core/services/access-token.service';
import { AccountSwitchService } from '@core/services/account-switch.service';
import { tenantSwitchingAnimation } from '@core/animations/core.animation';
import { HttpCancelService } from '@core/services/http-cancel.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-sso-login-success',
    templateUrl: './sso-login-success.component.html',
    styleUrls: ['./sso-login-success.component.scss'],
    animations: [
        tenantSwitchingAnimation
    ]
})
export class SsoLoginSuccessComponent implements OnInit, AfterViewInit {

    // Public
    public coreConfig: CoreConfig; // Layout Setting Config
    public imageStatus: string = 'initial';

    // Private
    private _counter: number = 0;

    /**
     * constructor
     * 
     * @param {Router} _router 
     * @param {ActivatedRoute} _route 
     * @param {AccessTokenService} _accessTokenService 
     * @param {AccountSwitchService} _accountSwitchService 
     * @param {CoreConfigService} _coreConfigService 
     * @param {UtilsService} _utilsService
     * @param {HttpCancelService} _httpCancelService
     */
    constructor(private _route: ActivatedRoute,
        private _router: Router,
        private _accessTokenService: AccessTokenService,
        private _accountSwitchService: AccountSwitchService,
        private _coreConfigService: CoreConfigService,
        private _utilsService: UtilsService,
        private _httpCancelService: HttpCancelService,
                private _translate: TranslateService) {

        // Set Blank Page
        this._coreConfigService.setConfig({
            layout: {
                footer: { hidden: true },
                menu: { hidden: true },
                navbar: { hidden: true },
                buyNow: false,
                customizer: false,
                scrollTop: false,
                enableLocalStorage: false,
                skin: "dark",
                type: "vertical"
            }
        });
    }

    //  Accessors
    // -----------------------------------------------------------------------------------------------------

    // Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {

        // Assign Query Data
        this._route.queryParams.subscribe((params) => {
            try {
                if (params.username && params.code && params.clientId) this._accessPage(params.username, params.code, params.clientId);
                else this._router.navigate(['/login']);
            }
            catch (error) {
                this._utilsService.alert('error', this._translate.instant('AUTH.FAIL_SIGN_IN'), error);
                this._router.navigate(['/login']);
            }
        });
    }

    /**
     * after view initial
     */
    ngAfterViewInit(): void {
        setTimeout(() => { this.imageStatus = 'end'; }, 0);
    }

    // Private methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * get qrcode
     * 
     * @param {string} username 
     * @param {string} code 
     */
    private _accessPage(username: string, code: string, clientId: string): void {
        this._utilsService.alert('success', this._translate.instant('AUTH.SSO_LOGIN_SUCCESS'), '');
        this._accessTokenService.initialAccessToken({
            code,
            clientId,
            username: username.toLowerCase()
        }).subscribe((returnData) => {
            this._accountSwitchService.switchAccount(returnData.data); // Switch Account
        }, (error) => {
            this._utilsService.alert('error', this._translate.instant('AUTH.FAIL_SIGN_IN'), error);
            this._router.navigate(['/login']);
        });
    }

    // Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * On animtion completed
     */
    public onAnimationDone(event: any): void {
        if (event.fromState === "initial" && event.toState === "end") {
            this.imageStatus = 'initial';
            this._counter++;
            if (this._counter < 15)
                setTimeout(() => { this.imageStatus = 'end'; });
            else {
                this._httpCancelService.cancelPendingRequests();
                this._router.navigate(['/login'], { replaceUrl: true });
                this._utilsService.alert('error', this._translate.instant('AUTH.FAIL_AUTO_LOGIN'), '');
            }
        }
        else return;
    }
}